import { useMutation, useQueryClient } from '@tanstack/react-query'

import { getProfileClientMedicalSheetQueryKey } from '@/ui/hooks/queries/useProfileClientMedicalSheetQuery '

import { responsibleMedicalRecordInstance } from '../..'
import { ResponsibleMedicalRecordLink } from '../../domain/models/MedicalRecordLink'
import { getListResponsibleMedicalRecordQueryKey } from './useListResponsibleMedicalRecordQuery'

export function getCreateResponsibleMedicalRecordLinkMutationKey() {
  return ['createResponsibleMedicalRecordLink']
}

export function useCreateResponsibleMedicalRecordLinkMutation({
  onSuccess,
  onError
}: {
  onSuccess?: (data: ResponsibleMedicalRecordLink) => void
  onError?: () => void
} = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: getCreateResponsibleMedicalRecordLinkMutationKey(),
    mutationFn: async (params: { patientId: string }) =>
      await responsibleMedicalRecordInstance.createResponsibleMedicalRecordLink(
        params
      ),
    onSuccess: (data, { patientId }) => {
      queryClient.invalidateQueries({
        queryKey: getListResponsibleMedicalRecordQueryKey()
      })
      queryClient.invalidateQueries({
        queryKey: getProfileClientMedicalSheetQueryKey(patientId)
      })
      onSuccess?.(data)
    },
    onError: () => {
      onError?.()
    }
  })
}
